define.alias("ember-math-helpers/helpers/asinh", "media/helpers/asinh");